<template>
    <q-page>
      <q-container>
        <div class="main-container">
          <div class="sub-container">
            <div class="content">
              <h6>Enter Password</h6>
              <p>Enter the password for dhivakarvasu2000@gmail.com to login to your account</p>
              <div class="login-form">
                <div class="password-container">
                  <label for="password">Password</label>
                  <q-link @click="popup">Reset Password</q-link>
                </div>
                <div>
                    <q-dialog v-model="showEdit" :class="{ 'bg-white': true }">
                        <q-card style="background-color:white!important; width: 500px; height: 500px;">
                            <q-card-section>
                                <div class="Reset-form">
                                    <div class="password-reset">
                                        <h5>Password Reset</h5>
                                        <p>Your New Password Should Different from old password</p>
                                    </div>
                                    <div class="img-field">
                                        <img src="../assets/uniqin_new_logo.png" alt="Emoji" width="100px" height="100px">
                                    </div>
                                    <div class="password-inputcontainer">
                                        <q-input type="password" class="password-field" v-model="password" label="Enter Your New Password" />
                                        <q-input type="password" class="confirmpassword-field" v-model="confirmpassword" label="Confirm Your New Password" />
                                       

                                    </div>
                                    <div class="button-container">
                                        <q-btn class="btn">Save New Password</q-btn>
                                    </div>
                                </div>
                            
                            </q-card-section>
                            
                        </q-card>
                    </q-dialog>
                </div>
                <div class="input-container">
                  <input type="password" placeholder="Enter a password" class="input-field" id="password">
                </div>
              </div>
              <div style="margin-top: 20px;">
                <q-btn class="q-btn-login" @click="login">Login</q-btn>
              </div>
              <div style="display: flex; margin-top: 10%;">
                <q-link @click="submitForm" class="text-red"  style="cursor: pointer;">Login via OTP</q-link>
              </div>
            </div>
          </div>
        </div>
      </q-container>
    </q-page>
  </template>
<style>
*{
    box-sizing: border-box;
    font-family: 'Arial Narrow', Arial, sans-serif;
}
.main-container{
    background-image: rgb(120, 36, 36);
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin: 0;

}
.sub-container{
    background-color: rgba(124, 92, 176, 0.3);
    border-radius: 20px;
    padding: 30px;
    max-width: 500px;
    text-align: center;
    border: 2px solid blue;
}
.password-container{
    display: flex; 
    justify-content: space-between;
}
.input-container> .input-field{
    width: 100%; border: none; 
    background-color: rgb(248, 246, 243); 
    border-bottom: 1px solid red; 
    padding: 10px; 
}
.q-btn-login{
    width: 100%; 
    background-color: rgb(78, 29, 8); 
    color: white;
}
.Reset-form{
    background-color: white;
    height: 100%;
}

.password-reset{
    display: block;
    justify-content: center;
    text-align: center;
}
.password-inputcontainer{
    display: block;
    justify-content: center;
}
.password-field{
    width: 50%;
    margin: 20px auto;
    
}
.confirmpassword-field{
    width: 50%;
    margin: 20px auto;
}
.img-field{
    display: flex;
  justify-content: center;
}
.button-container{
    display: flex;
    justify-content: center;
}
.btn{
    background-color: rgb(83, 83, 220);
    color: white;
    margin: 25px auto;
}



</style>
<script>
export default{
    name: 'verifyAccount',
    data(){
        return{
        otp:["","","",""],
        showEdit:false,
        password:'',
        confirmpassword:'',
        };
    },
    
    methods:{
        submitForm() {
            this.$router.push('/testing')
         },

  popup(){
    this.showEdit= true;

  }

    }

}


</script>